define("shared/components/shared/modal/navigation", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::NavigationArrows @navigate={{@navigate}} />
  */
  {
    "id": "ZOs4gfJi",
    "block": "[[[8,[39,0],null,[[\"@navigate\"],[[30,1]]],null]],[\"@navigate\"],false,[\"shared/ui/navigation-arrows\"]]",
    "moduleName": "shared/components/shared/modal/navigation.hbs",
    "isStrictMode": false
  });

  class NavigationComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "LEFT_ARROW", [37, 'ArrowLeft']);

      _defineProperty(this, "RIGHT_ARROW", [39, 'ArrowRight']);

      this.boundKeyHandler = this._keyHandler.bind(this);
      document.addEventListener('keyup', this.boundKeyHandler);
    }

    willDestroy() {
      super.willDestroy(...arguments);
      document.removeEventListener('keyup', this.boundKeyHandler);
    }

    _keyHandler(event) {
      const key = event.key || event.keyCode;

      if (this.LEFT_ARROW.includes(key)) {
        this.args.navigate(false);
      }

      if (this.RIGHT_ARROW.includes(key)) {
        this.args.navigate(true);
      }
    }

  }

  _exports.default = NavigationComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NavigationComponent);
});